import { render, staticRenderFns } from "./BaseList.vue?vue&type=template&id=0ee04f0a"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"
import style0 from "./BaseList.vue?vue&type=style&index=0&id=0ee04f0a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee04f0a')) {
      api.createRecord('0ee04f0a', component.options)
    } else {
      api.reload('0ee04f0a', component.options)
    }
    module.hot.accept("./BaseList.vue?vue&type=template&id=0ee04f0a", function () {
      api.rerender('0ee04f0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/goods/components/BaseList.vue"
export default component.exports